import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-promotions-tab',
  templateUrl: './promotions-tab.component.html',
})
export class PromotionsTabComponent {
  @Output() navigateToSales = new EventEmitter<void>();
  @Output() promoSavedState = new EventEmitter<boolean>();

  isPromoCreationSuccess = false;
  toggleSalesChallengeModalOpen = false;

  onBackClick() {
    if (!this.isPromoCreationSuccess) {
      this.toggleSalesChallengeModalOpen = true;
    } else {
      this.navigateToSales.emit();
    }
  }

  onToggleSalesChallengeConfirm() {
    this.toggleSalesChallengeModalOpen = false;
    this.navigateToSales.emit();
  }

  closeToggleSalesChallengeModal() {
    this.toggleSalesChallengeModalOpen = false;
  }

  promoCompleteStatus(event: any) {
    this.isPromoCreationSuccess = event;
    this.promoSavedState.emit(event);
  }

  promoSubmittedStatus(event: any) {
    if (event) {
      this.navigateToSales.emit();
    }
  }
}
